export default __webpack_public_path__ + "static/media/Chris_evans.044aa94e.jpg";